<template>
  <div class="redeem-action" @click="openDetailPage">
    <img :src="require('@/assets/icons/coupon.svg')" alt="Redeem" class="redeem-icon" />
    <div class="redeem-text">Redeem Code</div>
  </div>
</template>

<script>
export default {
  name: 'RedeemAction',
  props: {
    learningUnitId: {
      type: [Number, String],
      required: true
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    openDetailPage() {
      if (this.redirectUrl) {
        const url = new URL(this.redirectUrl, window.location.origin);
        url.searchParams.set('action', 'redeem');
        window.location.href = url.toString();
      }
    }
  }
};
</script>

<style scoped>
.redeem-action {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px; /* Add some spacing from the element above */
}

.redeem-icon {
  width: 20px; /* Adjust size as needed, assumed based on icon type */
  height: 20px;
}

.redeem-text {
  font-size: 15.2px;
  color: #159c34; /* Matching existing text color */
  text-decoration: underline;
}
</style>
